import React, { useState, useEffect } from 'react'
import { Form, Modal, Input } from 'antd'
import RowLayout from '../../commons/RowLayout/RowLayout'
import IconSelector from '../../commons/IconSelector/IconSelector'

const TopbarMenuModal = ({ T, isOpen, onCancel, onOk, info = {} }) => {
    let [icon, setIcon] = useState(info.icon)

    const [form] = Form.useForm()

    useEffect(() => {
        if (isOpen) {
            console.log(info)
            setIcon(info.icon)
            form.setFieldsValue({
                title: info.text
            })
        }
    }, [isOpen])

    function onFinish(values) {
        let data = {
            icon,
            text: values.title
        }
        onOk(data)
    }

    function onChangeIcon(icon) {
        setIcon(icon)
    }

    return (
        <Modal
            form={form}
            width={640}
            title={T('FOOTER_CONTACT')}
            visible={isOpen}
            centered
            okText={T('SAVE')}
            cancelText={T('CANCEL')}
            onOk={() => {
                form.validateFields()
                    .then(values => {
                        form.resetFields()
                        onFinish(values)
                    })
                    .catch(err => {
                        console.log('Validate Failed:', err)
                    })
            }}
            onCancel={() => onCancel()}>
            <Form form={form}>
                <RowLayout title={T('ICON')} contentSpan={16}>
                    <IconSelector
                        T={T}
                        selectedIcon={icon}
                        onSelect={onChangeIcon.bind(this)}
                    />
                </RowLayout>
                <RowLayout title={T('TEXT')} contentSpan={16}>
                    <Form.Item name="title">
                        <Input placeholder={T('TEXT')} />
                    </Form.Item>
                </RowLayout>
            </Form>
        </Modal>
    )
}

export default TopbarMenuModal
